<template>
  <transition name="cookie-banner">
    <div 
      v-if="visible"
      class="cookie-banner fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-xl"
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-description"
    >
      <div class="container mx-auto px-4 py-4 md:py-6">
        <div class="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
          <!-- Icon & Text -->
          <div class="flex items-start gap-4 flex-1 min-w-0">
            <div class="icon-circle-md bg-red-50">
              <PhCookie :size="20" weight="fill" class="text-red-600 md:w-6 md:h-6" />
            </div>
            <div class="flex-1 min-w-0">
              <h3 id="cookie-banner-title" class="text-base md:text-lg font-bold text-gray-900 mb-1">
                Мы используем файлы cookie
              </h3>
              <p id="cookie-banner-description" v-typo class="text-sm md:text-base text-gray-600 leading-relaxed">
                Мы используем файлы cookie для улучшения работы сайта и персонализации контента. 
                Продолжая использовать сайт, вы соглашаетесь с нашей 
                <router-link 
                  to="/policy" 
                  class="text-red-600 hover:text-red-700 underline font-medium transition-colors"
                  @click="handlePolicyClick"
                >
                  Политикой конфиденциальности
                </router-link>.
              </p>
            </div>
          </div>

          <!-- Actions -->
          <div class="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <button
              @click="handleAccept"
              class="btn-action-primary bg-red-600 hover:bg-red-700 sm:w-auto w-full"
              aria-label="Принять использование файлов cookie"
            >
              <PhCheck :size="16" weight="regular" />
              Принять все
            </button>
            <button
              @click="handleReject"
              class="btn-action-secondary sm:w-auto w-full"
              aria-label="Отклонить использование файлов cookie"
            >
              <PhX :size="16" weight="regular" />
              Отклонить
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { PhCookie, PhCheck, PhX } from '@phosphor-icons/vue'

const COOKIE_CONSENT_KEY = 'cookie_consent'
const COOKIE_CONSENT_ACCEPTED = 'accepted'
const COOKIE_CONSENT_REJECTED = 'rejected'

export default {
  name: 'CookieBanner',
  components: {
    PhCookie,
    PhCheck,
    PhX
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    this.checkCookieConsent()
  },
  methods: {
    checkCookieConsent() {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY)
      if (!consent) {
        // Показываем баннер с небольшой задержкой для лучшего UX
        setTimeout(() => {
          this.visible = true
        }, 1000)
      }
    },
    handleAccept() {
      localStorage.setItem(COOKIE_CONSENT_KEY, COOKIE_CONSENT_ACCEPTED)
      this.hide()
      this.$emit('accepted')
    },
    handleReject() {
      localStorage.setItem(COOKIE_CONSENT_KEY, COOKIE_CONSENT_REJECTED)
      this.hide()
      this.$emit('rejected')
    },
    handlePolicyClick() {
      // Баннер остается открытым, пользователь может вернуться
    },
    hide() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.cookie-banner {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.cookie-banner-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.cookie-banner-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.cookie-banner-enter-from {
  opacity: 0;
  transform: translateY(100%);
}

.cookie-banner-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.cookie-banner-enter-to,
.cookie-banner-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* Адаптивность для мобильных */
@media (max-width: 640px) {
  .cookie-banner {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
}
</style>
